import Section from '../ui/Section';
import styles from './About.module.css';

export default function About() {
  return (
    <Section id="about" eyebrow="About Brian" title="25+ years of unforgettable experiences." wide>
      <div className={styles.layout}>
        <img src="/rcp-9108.webp" alt="Brian Dawson" className={styles.headshot} />
        <div>
          <p>
            Brian Dawson Music guarantees excitement, fun, and unforgettable experiences. Regardless of
            nationality, race, age, or the nature of the event, Brian Dawson has the talent and expertise
            to engage and entertain all audiences. With over 25 years of experience, Brian has performed
            at prestigious events, including serving as the DJ for President and First Lady Biden, Vice
            President Kamala Harris, the Participate International Teachers Convention, Bimb&eacute;
            Festival, the NAIA Championship Game, and countless major concerts, community events,
            brunches, and celebrity functions. Brian Dawson's extensive experience will elevate your
            event to new heights.
          </p>
          <p>
            Throughout his career, Brian has interviewed, collaborated, and coordinated projects with
            numerous high-profile figures, including Jay-Z, Diddy, John Legend, Ludacris, Ne-Yo, Alicia
            Keys, Rick James, 50 Cent, T.I., Usher, Chris Brown, Migos, former President Barack Obama,
            Hillary Clinton, current Vice President Kamala Harris, Pastor Shirley Caesar, and NBA legend
            Magic Johnson. His television appearances include hosting and featuring on shows such as
            Love It or List It, BET's Rap City, Keepin' It Reel TV, FOX 50's Gimme the Mike, MTV's The
            Dance, and his own highly rated behind-the-scenes program, The B Spot, on FOX 50.
          </p>
        </div>
      </div>
    </Section>
  );
}
